import React, { useEffect, useReducer, useState, useRef } from 'react'
import { useForm, Controller } from 'react-hook-form'
import { useLocation, useHistory } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles'
import mapboxgl from 'mapbox-gl/dist/mapbox-gl-csp'
// eslint-disable-next-line import/no-webpack-loader-syntax
import RoomIcon from '@material-ui/icons/Room'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import CircularProgress from '@material-ui/core/CircularProgress'
import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import Paper from '@material-ui/core/Paper'
import TextField from '@material-ui/core/TextField'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import InputLabel from '@material-ui/core/InputLabel'

import { get, post, put, del } from '../../config/fetch'
import AlertWrapper from '../common/alert'
import { TOKEN_CREATE_BASE_STATION, TOKEN_UPDATE_BASE_STATIONS } from '../../constants/constants'

const useStyles = makeStyles(theme => ({
    map: {
        position: 'relative',
        width: '98%',
        margin: '1em auto',
        padding: '1em',
        height: 'calc(100% - 2em)',
        overflowY: 'auto',
        [theme.breakpoints.down('md')]: {
            height: '300px',
        },
    },
    circularProgress: {
        width: '100%',
        overflowY: 'auto',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '550px',
        [theme.breakpoints.down('md')]: {
            height: '300px',
        },
    },
}))

const defaultCenter = {
    lng: -80.287839,
    lat: 25.963922,
}

const baseStationElement = () => {
    let el = document.createElement('div')
    el.className = 'marker-basestation'
    el.style.backgroundImage =
        'url(https://iconsplace.com/wp-content/uploads/_icons/ffffff/256/png/radio-tower-icon-18-256.png)'
    el.style.width = '40px'
    el.style.height = '40px'
    el.style.backgroundSize = '100%'
    el.style.opacity = '0.7'
    return el
}

function DialogDelete(props) {
    const { classes, handleCloseDialogDelete, state, handleDeleteBaseStation, visible } = props

    return (
        <Dialog
            open={visible}
            onClose={handleCloseDialogDelete}
            aria-labelledby="form-dialog-title"
        >
            <DialogTitle id="form-dialog-title">Delete Base Station</DialogTitle>
            <DialogContent>
                <DialogContentText>Are you sure to delete this base station?</DialogContentText>
                {state.loading && (
                    <div className={classes.wrapperLoader}>
                        <CircularProgress />
                    </div>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCloseDialogDelete} color="primary" disabled={state.loading}>
                    Cancel
                </Button>
                <Button
                    onClick={() => handleDeleteBaseStation(state.id)}
                    color="primary"
                    type="submit"
                    disabled={state.loading}
                >
                    Delete
                </Button>
            </DialogActions>
        </Dialog>
    )
}

function BaseStationsDetail(props) {
    const { action } = props
    const { handleSubmit, control, setValue, getValues } = useForm()
    const classes = useStyles()
    const location = useLocation()
    const history = useHistory()
    const mapContainer = useRef()
    const [map, setMap] = useState(null)
    const [state, setState] = useReducer((s, a) => ({ ...s, ...a }), {
        error: null,
        loading: true,
        resolved: false,
        baseStation: {},
        message: null,
        typeMessage: null,
        visibleMessage: false,
    })
    const [stateDialogDelete, setStateDialogDelete] = useReducer((s, a) => ({ ...s, ...a }), {
        loading: false,
        visible: false,
        id: null,
    })
    const baseStationId = location.pathname.split('/')[2]

    useEffect(() => {
        let map = null

        if (action === 'create') {
            setState({
                ...state,
                loading: false,
                resolved: true,
            })
            map = initMap(defaultCenter.lat, defaultCenter.lng)

            return () => map.remove()
        } else if (action === 'update') {
            const id = location.pathname.split('/')[2]
            fetchBaseStation(id).then(bs => {
                setState({
                    ...state,
                    loading: false,
                    resolved: true,
                    baseStation: bs,
                })
                map = initMap(bs.location.coordinates[1], bs.location.coordinates[0])

                return () => map.remove()
            })
        }
    }, [])

    const fetchBaseStation = async id => {
        try {
            const { data: baseStation } = await get(
                `/baseStations/${id}?code=aZqDt3i8bAPABOyydkjArO9K1R23b%2FUAT9IJhdhaGBNrx%2FKP7o45Uw%3D%3D`,
            )

            return baseStation
        } catch (e) {
            throw new Error(e)
        }
    }

    const initMap = (lat, lng) => {
        const map = new mapboxgl.Map({
            container: mapContainer.current,
            style: 'mapbox://styles/mapbox/dark-v9',
            center: [lng, lat],
            zoom: 12,
        })
        const el = baseStationElement()
        const marker = new mapboxgl.Marker({ element: el }).setLngLat([lng, lat]).addTo(map)

        map.on('move', () => {
            marker.setLngLat([map.getCenter().lng.toFixed(4), map.getCenter().lat.toFixed(4)])
        })

        map.on('moveend', () => {
            setValue('latitude', map.getCenter().lat.toFixed(6))
            setValue('longitude', map.getCenter().lng.toFixed(6))
        })

        map.on('load', () => {
            setMap(map)
        })

        return map
    }

    const handleForm = async data => {
        setState({
            ...state,
            loading: true,
            resolved: false,
        })

        if (action === 'create') {
            const responseCreate = await createBaseStation(data)
            if (responseCreate.success) {
                setState({
                    loading: false,
                    resolved: true,
                    visibleMessage: true,
                    typeMessage: 'success',
                    message: `Base station has been saved successfuly.`,
                })
            } else {
                setState({
                    loading: false,
                    resolved: true,
                    error: responseCreate.errors[0].msg,
                    visibleMessage: true,
                    typeMessage: 'error',
                    message: responseCreate.errors[0].msg,
                })
            }
        } else if (action === 'update') {
            const id = location.pathname.split('/')[2]
            const responseUpdate = await updateBaseStation(id, data)
            if (responseUpdate.success) {
                setState({
                    loading: false,
                    resolved: true,
                    visibleMessage: true,
                    typeMessage: 'success',
                    message: `Base station has been updated successfuly.`,
                })
            } else {
                setState({
                    loading: false,
                    resolved: true,
                    error: responseUpdate.errors[0].msg,
                    visibleMessage: true,
                    typeMessage: 'error',
                    message: responseUpdate.errors[0].msg,
                })
            }
        }
    }

    const handleClickDelete = id => {
        setStateDialogDelete({
            ...stateDialogDelete,
            visible: true,
            id,
        })
    }

    const handleCloseDialogDelete = () => {
        setStateDialogDelete({
            ...stateDialogDelete,
            visible: false,
            id: null,
        })
    }

    const handleDeleteBaseStation = async id => {
        setStateDialogDelete({
            ...stateDialogDelete,
            loading: true,
        })
        deleteBaseStation(id)
            .then(response => {
                setStateDialogDelete({
                    ...stateDialogDelete,
                    loading: false,
                    visible: false,
                })
                setState({
                    ...state,
                    visibleMessage: true,
                    typeMessage: 'success',
                    message: `Base station has been deleted successfully.`,
                })
                setTimeout(() => {
                    history.goBack()
                }, 1500)
            })
            .catch(error => {
                setStateDialogDelete({
                    ...stateDialogDelete,
                    loading: false,
                })
            })
    }

    const createBaseStation = async data => {
        try {
            const dataResponse = await post(
                `/baseStations?code=${TOKEN_CREATE_BASE_STATION}`,
                data,
            )
            return dataResponse
        } catch (e) {
            throw new Error(e)
        }
    }

    const deleteBaseStation = async id => {
        try {
            const { data: baseStation } = await del(
                `/baseStations/${id}?code=WbnLifyA0oaAT67HLe9bagKDwIRDz2W%2F1sy9aPA6rkA6NU5GlihNbA%3D%3D`,
            )

            return baseStation
        } catch (e) {
            throw new Error(e)
        }
    }

    const updateBaseStation = async (id, data) => {
        try {
            const dataResponse = await put(
                `/baseStations/${id}?code=${TOKEN_UPDATE_BASE_STATIONS}`,
                data,
            )

            return dataResponse
        } catch (e) {
            throw new Error(e)
        }
    }

    const handleCloseMessageReport = () => {
        setState({
            ...state,
            visibleMessage: false,
        })
    }

    const flyToLocation = () => {
        const values = getValues(['latitude', 'longitude'])
        map.flyTo({
            center: [Number(values[1]), Number(values[0])],
        })
    }

    const handleKeyPress = e => {
        if (e.key === 'Enter') {
            flyToLocation()
        }
    }

    const cidOrEnb = value => {
        const values = getValues(['cid', 'eNB'])
        return Boolean(!!values[0] + !!values[1])
    }

    return (
        <Grid container spacing={0}>
            <Grid container direction="row" justify="center" alignItems="center">
                <Grid item xs={11} direction="column" style={{ borderBottom: '1px solid' }}>
                    <h2>Base Station</h2>
                </Grid>
            </Grid>
            <Grid container direction="row" justify="center" alignItems="stretch">
                <Grid xs={11} lg={7} item>
                    <Paper
                        elevation={3}
                        style={{
                            width: '100%',
                            margin: '1em 0',
                            padding: '1em',
                            height: 'auto',
                            overflowY: 'auto',
                        }}
                    >
                        <Grid
                            xl={12}
                            container
                            direction="row"
                            justify="space-between"
                            alignItems="center"
                            style={{ borderBottom: '1px solid #111' }}
                        >
                            <h3>Information</h3>
                        </Grid>
                        {state.resolved ? (
                            <form onSubmit={handleSubmit(handleForm)}>
                                <Grid
                                    container
                                    direction="row"
                                    style={{ padding: '1em 0' }}
                                    justify="space-between"
                                    alignItems="center"
                                    spacing={4}
                                >
                                    <Grid item xs={12} md={6} lg={6}>
                                        <Controller
                                            defaultValue={state.baseStation.cid}
                                            control={control}
                                            name="cid"
                                            rules={{ required: false, validate: cidOrEnb }}
                                            render={({ field, fieldState }) => (
                                                <TextField
                                                    {...field}
                                                    autoFocus
                                                    margin="dense"
                                                    label="CID"
                                                    type="text"
                                                    fullWidth
                                                    inputRef={field.ref}
                                                    error={fieldState.invalid}
                                                />
                                            )}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6} lg={6}>
                                        <Controller
                                            defaultValue={state.baseStation.eNB}
                                            control={control}
                                            name="eNB"
                                            rules={{ required: false, validate: cidOrEnb }}
                                            render={({ field, fieldState }) => (
                                                <TextField
                                                    {...field}
                                                    autoFocus
                                                    margin="dense"
                                                    label="eNB"
                                                    type="text"
                                                    fullWidth
                                                    inputRef={field.ref}
                                                    error={fieldState.invalid}
                                                />
                                            )}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid
                                    container
                                    direction="row"
                                    style={{ padding: '1em 0' }}
                                    justify="space-between"
                                    alignItems="center"
                                    spacing={4}
                                >
                                    <Grid item xs={12} md={6}>
                                        <InputLabel id="network-type-label">
                                            Network type *
                                        </InputLabel>
                                        <Controller
                                            control={control}
                                            defaultValue={state.baseStation.networkType || ''}
                                            name="networkType"
                                            rules={{ required: true }}
                                            render={({ field, fieldState }) => (
                                                <Select
                                                    {...field}
                                                    labelId="network-type-label"
                                                    id="network-type"
                                                    fullWidth
                                                    required
                                                    inputRef={field.ref}
                                                    error={fieldState.invalid}
                                                >
                                                    <MenuItem value="">
                                                        <em>Select network type</em>
                                                    </MenuItem>
                                                    <MenuItem value="LTE">LTE</MenuItem>
                                                    <MenuItem value="CDMA">CDMA</MenuItem>
                                                </Select>
                                            )}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <InputLabel id="mobile-generation-label">
                                            Mobile generation *
                                        </InputLabel>
                                        <Controller
                                            control={control}
                                            defaultValue={state.baseStation.mobileGeneration || ''}
                                            name="mobileGeneration"
                                            rules={{ required: true }}
                                            render={({ field, fieldState }) => (
                                                <Select
                                                    {...field}
                                                    labelId="mobile-generation-label"
                                                    id="mobile-generation"
                                                    fullWidth
                                                    required
                                                    inputRef={field.ref}
                                                    error={fieldState.invalid}
                                                >
                                                    <MenuItem value="">
                                                        <em>Select mobile generation</em>
                                                    </MenuItem>
                                                    <MenuItem value="3G">3G</MenuItem>
                                                    <MenuItem value="4G">4G</MenuItem>
                                                </Select>
                                            )}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid
                                    container
                                    direction="row"
                                    style={{ padding: '1em 0' }}
                                    justify="space-between"
                                    alignItems="center"
                                    spacing={2}
                                >
                                    <Grid item xs={12} md={12} lg={12}>
                                        <Controller
                                            control={control}
                                            defaultValue={state.baseStation.address}
                                            name="address"
                                            rules={{ required: true }}
                                            render={({ field, fieldState }) => (
                                                <TextField
                                                    {...field}
                                                    margin="dense"
                                                    label="Address"
                                                    type="text"
                                                    fullWidth
                                                    required
                                                    inputRef={field.ref}
                                                    error={fieldState.invalid}
                                                />
                                            )}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid
                                    container
                                    direction="row"
                                    style={{ padding: '1em 0' }}
                                    justify="space-between"
                                    alignItems="center"
                                    spacing={2}
                                >
                                    <Grid item xs={12} md={4} lg={4}>
                                        <Controller
                                            control={control}
                                            defaultValue={state.baseStation.mcc}
                                            name="mcc"
                                            rules={{ required: false }}
                                            render={({ field, fieldState }) => (
                                                <TextField
                                                    {...field}
                                                    margin="dense"
                                                    label="MCC"
                                                    type="number"
                                                    fullWidth
                                                    inputRef={field.ref}
                                                    error={fieldState.invalid}
                                                />
                                            )}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <Controller
                                            control={control}
                                            defaultValue={state.baseStation.mnc}
                                            name="mnc"
                                            rules={{ required: false }}
                                            render={({ field, fieldState }) => (
                                                <TextField
                                                    {...field}
                                                    margin="dense"
                                                    label="MNC"
                                                    type="number"
                                                    fullWidth
                                                    inputRef={field.ref}
                                                    error={fieldState.invalid}
                                                />
                                            )}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <Controller
                                            control={control}
                                            defaultValue={state.baseStation.lac}
                                            name="lac"
                                            rules={{ required: false }}
                                            render={({ field, fieldState }) => (
                                                <TextField
                                                    {...field}
                                                    margin="dense"
                                                    label="LAC"
                                                    type="number"
                                                    fullWidth
                                                    inputRef={field.ref}
                                                    error={fieldState.invalid}
                                                />
                                            )}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid
                                    container
                                    direction="row"
                                    style={{ padding: '1em 0' }}
                                    justify="space-between"
                                    alignItems="center"
                                    spacing={2}
                                >
                                    <Grid item xs={12} md={6} lg={4}>
                                        <Controller
                                            control={control}
                                            defaultValue={state.baseStation.aperture}
                                            name="aperture"
                                            rules={{ required: false }}
                                            render={({ field, fieldState }) => (
                                                <TextField
                                                    {...field}
                                                    margin="dense"
                                                    label="Aperture"
                                                    type="number"
                                                    fullWidth
                                                    inputRef={field.ref}
                                                    error={fieldState.invalid}
                                                />
                                            )}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6} lg={4}>
                                        <Controller
                                            control={control}
                                            defaultValue={state.baseStation.orientation}
                                            name="orientation"
                                            rules={{ required: false }}
                                            render={({ field, fieldState }) => (
                                                <TextField
                                                    {...field}
                                                    margin="dense"
                                                    label="Orientation"
                                                    type="number"
                                                    fullWidth
                                                    inputRef={field.ref}
                                                    error={fieldState.invalid}
                                                />
                                            )}
                                        />
                                    </Grid>
                                    <Grid item xs={12} lg={3}></Grid>
                                </Grid>
                                <Grid
                                    xl={12}
                                    container
                                    direction="row"
                                    justify="space-between"
                                    alignItems="center"
                                    style={{ borderBottom: '1px solid #111', marginTop: '2em' }}
                                >
                                    <h3>Location</h3>
                                </Grid>

                                <Grid
                                    container
                                    direction="row"
                                    style={{ padding: '1em 0' }}
                                    justify="space-between"
                                    alignItems="flex-end"
                                    spacing={2}
                                >
                                    <Grid item xs={10} md={5} lg={4}>
                                        <Controller
                                            name="latitude"
                                            defaultValue={
                                                state.baseStation.location
                                                    ? Number(
                                                          state.baseStation.location.coordinates[1],
                                                      )
                                                    : defaultCenter.lat
                                            }
                                            control={control}
                                            rules={{ required: true }}
                                            render={({ field, fieldState }) => (
                                                <TextField
                                                    {...field}
                                                    onKeyDown={handleKeyPress}
                                                    margin="dense"
                                                    label="Latitude"
                                                    type="number"
                                                    fullWidth
                                                    required
                                                    inputRef={field.ref}
                                                    error={fieldState.invalid}
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                />
                                            )}
                                        />
                                    </Grid>
                                    <Grid item xs={10} md={5} lg={4}>
                                        <Controller
                                            name="longitude"
                                            defaultValue={
                                                state.baseStation.location
                                                    ? Number(
                                                          state.baseStation.location.coordinates[0],
                                                      )
                                                    : defaultCenter.lng
                                            }
                                            control={control}
                                            rules={{ required: true }}
                                            render={({ field, fieldState }) => (
                                                <TextField
                                                    {...field}
                                                    onKeyDown={handleKeyPress}
                                                    margin="dense"
                                                    label="Longitude"
                                                    type="number"
                                                    fullWidth
                                                    required
                                                    inputRef={field.ref}
                                                    error={fieldState.invalid}
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                />
                                            )}
                                        />
                                    </Grid>
                                    <Grid item xs={2} md={2} lg={3} align="start">
                                        <Button
                                            type="button"
                                            variant="contained"
                                            color="default"
                                            onClick={flyToLocation}
                                        >
                                            Show in map
                                            <RoomIcon />
                                        </Button>
                                    </Grid>
                                </Grid>
                            </form>
                        ) : (
                            <div className={classes.circularProgress}>
                                <CircularProgress color="inherit" />
                            </div>
                        )}
                    </Paper>
                </Grid>
                <Grid xs={11} lg={4} item>
                    <Paper elevation={3} className={classes.map}>
                        <div className="map-container" ref={mapContainer} />
                    </Paper>
                </Grid>
            </Grid>
            <Grid
                container
                direction="row"
                justify="center"
                alignItems="center"
                style={{ margin: '2em 0' }}
            >
                <Grid xs={11} container direction="row" justify="flex-end" alignItems="center">
                    {action === 'update' && (
                        <Button
                            type="button"
                            variant="contained"
                            color="default"
                            onClick={() => handleClickDelete(baseStationId)}
                        >
                            delete
                        </Button>
                    )}
                    &nbsp;&nbsp;&nbsp;
                    <Button
                        type="button"
                        variant="contained"
                        color="primary"
                        onClick={handleSubmit(handleForm)}
                    >
                        save
                    </Button>
                </Grid>
            </Grid>
            <AlertWrapper
                description={state.message}
                handleClose={handleCloseMessageReport}
                type={state.typeMessage}
                visible={state.visibleMessage}
            />
            <DialogDelete
                classes={classes}
                handleCloseDialogDelete={handleCloseDialogDelete}
                state={stateDialogDelete}
                handleDeleteBaseStation={handleDeleteBaseStation}
                visible={stateDialogDelete.visible}
            />
        </Grid>
    )
}

export default BaseStationsDetail
